import { render, staticRenderFns } from "./ObservationTable.vue?vue&type=template&id=98ea6fe8&scoped=true"
import script from "./ObservationTable.vue?vue&type=script&lang=js"
export * from "./ObservationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ea6fe8",
  null
  
)

export default component.exports